import {BaseCachedService} from './Core/BaseCachedService';

class SurveyQuestionSecondaryFieldRequiredService extends BaseCachedService {
    get Url() { return super.Url + "/surveyQuestionSecondaryFieldRequireds"; }
}

export const service = new SurveyQuestionSecondaryFieldRequiredService();


